import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatError } from "../lib/api";
import { AuthShell } from "./Login";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Reset your password" subtitle="We'll email you a reset link">
      {sent ? (
        <div className="text-center py-4" data-testid="forgot-sent">
          <MailCheck className="w-12 h-12 text-emerald-500 mx-auto" />
          <p className="mt-4 text-slate-800">If an account exists for <b>{email}</b>, a reset link has been sent.</p>
          <Link to="/login" className="inline-block mt-6"><Button variant="outline">Back to sign in</Button></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" placeholder="you@clinic.com" />
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <Button type="submit" data-testid="forgot-submit" disabled={loading} className="w-full bg-slate-900 hover:bg-slate-800 h-11">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
          </Button>
          <p className="text-sm text-center text-slate-600"><Link to="/login" className="text-sky-600 hover:underline">Back to sign in</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
